export const activePage = state => state.activePage;

export const lastUpdate = state => state.lastUpdate;

export const interfaceDirty = state => state.interfaceDirty;

export const getCurrentApplicationId = state => state.currentApplicationId;

export const getCurrentProcessId = state => state.currentProcessId;

export const getShowMultiLangOption = state => state.showMultiLangOption;

export const getInfoApp = state => state.defaultInfoApp;

export const getShowSaveBtnByPermission = state => state.showSaveIfPermission;

export const getShowAccessibilityOption = state => state.showAccessibilityOption;

export const getShowEnableAI = state => state.showEnableAI;

export const getShowEnableTaskAI = state => state.showEnableTaskAI;

export const getDisableOnLoad = state => state.disableOnLoad;

export const getFromAccountDisabled = state => state.fromAccountDisabled;

export const getFromMyTeamsTasksMenu = state => state.fromMyTeamsTasksMenu;

export const getIsOnLoadApplication = state => state.isOnLoadApplication;

export const getNewProcessCreated = state => state.newProcessCreated;
